import { DOCUMENT } from '@angular/common';
import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, Renderer2} from '@angular/core';
import {SidebarService} from "./services/SidebarService";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements AfterViewInit,OnInit {

  private selector: string = 'initialState';
  isSidebarCollapsed = false;
  constructor(@Inject(DOCUMENT) private _document: Document, private _renderer: Renderer2, private sidebarService:SidebarService, private cdr: ChangeDetectorRef) {}
  ngOnInit() {
    this.sidebarService.isCollapsed$.subscribe(state => {
      this.isSidebarCollapsed = state;
      this.cdr.detectChanges();

      const aside = this._document.getElementById('side-bar');
      const mainContent = this._document.getElementById('main-contentid');
      const header = this._document.getElementById('header');

      if (aside) {
        if (state) aside.classList.add('active');
        else aside.classList.remove('active');
      }

      if (mainContent) {
        if (state) {
          mainContent.classList.add('main-content-active');
          mainContent.classList.remove('main-content');
        } else {
          mainContent.classList.remove('main-content-active');
          mainContent.classList.add('main-content');
        }
      }

      if (header) {
        header.style.paddingLeft = state ? '50px' : '250px';
      }
    });
  }


  ngAfterViewInit() {
    this.removeElementById(this.selector);

  }
  private applySidebarClasses(collapsed: boolean): void {
    const aside = this._document.getElementById('side-bar');
    if (collapsed) {
      aside?.classList.add('active');
    } else {
      aside?.classList.remove('active');
    }
  }



  private removeElementById(id: string): void {
    const element = this._document.getElementById(id);
    if (element && element.parentNode) {
      this._renderer.removeChild(element.parentNode, element);
    }
  }
}
